import styled from '@emotion/styled';

const StyledCountryDiv = styled.div(
  {
    'alignItems': 'center',
    'display': 'inline-flex',
    'justifyContent': 'center',
    'marginBottom': 12,
    'width': 'fit-content',
    '& svg': {
      marginRight: '5px'
    }
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.small
  })
);

export default StyledCountryDiv;
